import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import TrashCanOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useIsMobile } from '../../hooks';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const DeleteDocumentButton = ({ invoiceId, handleDelete, id }) => {
  const isMobile = useIsMobile();
  return (
    <IconButton
      size={isMobile ? 'small' : 'large'}
      id={id}
      disableRipple
      onClick={() => handleDelete(invoiceId)}
      sx={{
        padding: 0,
      }}
    >
      <TrashCanOutlineIcon className={DEFAULT_ICON_CLASS_NAME} />
    </IconButton>
  );
};

DeleteDocumentButton.propTypes = {
  invoiceId: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default DeleteDocumentButton;
